<div class="meal-radio-group">
  <div *ngFor="let item of MEAL_OPTIONS"
       class="meal-radio-group__option {{ item.name | lowercase }}"
       [class.disabled]="item.disabled"
       (click)="onInputSelected(item.id)">
    <label>{{ item.name }}</label>
    <input type="radio" name="meal" [value]="item.id" [checked]="value === item.id" />
    <span [class]="item.name.toLowerCase() + '-check'" *ngIf="value === item.id">
      <fa-icon [icon]="faCheckCircle"></fa-icon>
    </span>
  </div>
</div>